import { createFileRoute } from '@tanstack/react-router'
import { Departments } from '@/components/settings-route/user/departments/index.jsx'

export const Route = createFileRoute('/_auth/settings/users/departments')({
  component: Departments,
})
